<template>
    <div>FOOTER</div>
</template>

<script>
export default {
    name: "Footer"
}
</script>

<style scoped>

</style>